import React, { ReactNode, useEffect, useState } from 'react';
import { Table, TableProps } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { JTableBody, JTableRow, DragHandle } from './components';
import { array_move } from '../lib';
import './style.css';

export type JTableProps<RecordType extends Record<string, unknown>> = {
    /** Table is sortable */
    sortable?: boolean;
    /** On Sort End - usa il nuovo array ordinato e il nuovo indice */
    onSortEnd?: (newData: RecordType[], newIndex: number) => void;
    /** Table has header **/
    title?: ReactNode;
    /** Table without border */
    noBorderTable?:boolean
};

/**
 * Jnext Table
 *
 * @param sortable
 * @param sortKey
 * @param dataSource
 * @param otherProps
 * @constructor
 */

const JTable = <RecordType extends Record<string, unknown>>({
                                                                sortable = false,
                                                                title,
                                                                dataSource,
                                                                columns,
                                                                onSortEnd,
                                                                rowKey,
                                                                noBorderTable = false,
                                                                ...otherProps
                                                            }: JTableProps<RecordType> & TableProps<RecordType>) => {
    const [cols, setColumns] = useState<ColumnsType<RecordType> | undefined>([]);
    const [data, setData] = useState<RecordType[]>([]);

    useEffect(() => {
        setColumns(columns);
    }, [columns]);

    useEffect(() => {
        const d = dataSource ? [...dataSource] : [];
        setData(d);
    }, [dataSource]);

    useEffect(() => {
        if (sortable) {
            const c = columns
                ? [
                    {
                        title: ' ',
                        dataIndex: 'x',
                        width: 30,
                        className: 'drag-visible',
                        render: () => <DragHandle />,
                    },
                    ...columns,
                ]
                : cols;
            setColumns(c);
        }
    }, [sortable, columns]);

    const onEnd = ({ oldIndex, newIndex }: any) => {
        if (
            oldIndex !== newIndex &&
            typeof rowKey === 'string' &&
            dataSource !== undefined
        ) {
            const newData = array_move([...dataSource], oldIndex, newIndex, rowKey);
            setData(newData);
            if (onSortEnd) onSortEnd(newData, newIndex);
        }
    };

    const bodyWrapper = (props: any) => (
        <JTableBody sortable={sortable} {...props} onSortEnd={onEnd} />
    );

    const rowWrapper = (props: any) => (
        <JTableRow
            sortable={sortable}
            rowKey={rowKey}
            data={dataSource}
            {...props}
        />
    );

    return (
        <>
            {title}
            <Table
                {...otherProps}
                className={noBorderTable ? 'noBorderTable': ''}
                rowKey={rowKey}
                dataSource={data}
                columns={cols}
                components={{
                    body: {
                        wrapper: bodyWrapper,
                        row: rowWrapper,
                    },
                }}
            />
        </>
    );
};

JTable.displayName = 'JTable';
export { JTable };
